import { isObject } from 'lodash';

import { Sort } from '@angular/material/sort';

export function isMatSort(object: any): object is Sort {
  return isObject(object) && 'active' in object && 'direction' in object;
}
